export const activateSession = "ACTIVATE_SESSION";
export const deactivateSession = "DEACTIVATE_SESSION";
export const loadingSession = "LOADING_SESSION";

export const setCookie = "SET_COOKIE";
export const removeCookie = "REMOVE_COOKIE";
export const getCookie = "GET_COOKIE";

export const setLocalStorageItem = "SET_LOCAL_STORAGE_ITEM";
export const removeLocalStorageItem = "REMOVE_LOCAL_STORAGE_ITEM";
export const clearLocalStorage = "CLEAR_LOCAL_STORAGE";
